var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/UserClassifierRepo/Migration/EntityVersionData.ts";
import * as t from 'io-ts';
import { Id } from '../../Id';
import { Version } from '../../Version';
export var EntityVersionData = t.type({
  type: t.literal('EntityVersionData'),
  entityId: t.recursion('entityId', function () {
    return Id;
  }),
  currentVersion: t.recursion('currentVersion', function () {
    return Version;
  }),
  latestVersion: t.recursion('latestVersion', function () {
    return Version;
  })
}, 'EntityVersionData');